





























import {Vue, Component, Model, Prop} from 'vue-property-decorator';
import { debounce } from 'typescript-debounce-decorator';
import PersonDTO from "@/dto/person/PersonDTO";
import PersonService from "@/services/PersonService";
import PersonFilterDTO from "@/dto/person/PersonFilterDTO";

@Component({})
export default class PersonSearch extends Vue {

	@Model('change', {type: PersonDTO, default: null})
	private selectedPerson!: PersonDTO | null;

	@Prop({default: "persons"})
	private name!: string

	@Prop({default: "Person name"})
	private label!: string;

	@Prop({default: "Type person name"})
	private placeholder!: string;

	private filter = new PersonFilterDTO({pageSize: 8});

	private persons: Array<PersonDTO> = [];

	private showList = false;

	private dropUp = false;

	mounted(){
		if(this.selectedPerson){
			this.filter.fullNameFilter = this.selectedPerson.firstName + ' ' + this.selectedPerson.lastName;
		}
	}

	@debounce(200)
	search(){
		PersonService.getByFilter(this.filter).then(
			ok => {
				this.persons = ok.data.data;
				this.showList = true;
				this.$nextTick(() => {
					this.updateDropDownPosition();
				});
			},
			err => {
				console.log(JSON.stringify(err))
			}
		)
	}

	private updateDropDownPosition() {
		const inputEl = this.$el.querySelector('input');
		const autocompleteEl = this.$refs.autocomplete as HTMLElement;
		if (!inputEl || !autocompleteEl) return;

		const inputRect = inputEl.getBoundingClientRect();
		const windowHeight = window.innerHeight;

		const spaceBelow = windowHeight - inputRect.bottom - 15;
		const spaceAbove = inputRect.top - 15;

		if (spaceBelow < 180 && spaceAbove > spaceBelow) {
			this.dropUp = true;
			autocompleteEl.style.maxHeight = `${spaceAbove}px`;
		} else {
			this.dropUp = false;
			autocompleteEl.style.maxHeight = `${Math.max(120, spaceBelow)}px`;
		}
	}

	selectPerson(p: PersonDTO){
		this.showList = false;
		// this.selectedPerson = p;
		this.filter.fullNameFilter = p.firstName + ' ' + p.lastName;
		this.$emit('change', p);
	}

}
